export enum AccountNavigationLabel {
  AccountProfile = 'Account Profile',
  TeamManagement = 'Team Management',
  Notifications = 'Notifications',
}

export const ACCOUNT_NAVIGATION_LINKS = [
  {
    label: AccountNavigationLabel.AccountProfile,
    pathname: '/identity/user/account',
  },
  {
    label: AccountNavigationLabel.TeamManagement,
    pathname: '/identity/user/account/team-management',
  },
  {
    label: AccountNavigationLabel.Notifications,
    pathname: '/identity/user/account/notification-preferences',
  },
];
